/**
 * Edge-style gallery grid for tag pages.
 *
 * 1. Lays the tiles out as a real masonry grid (mixed portrait/landscape
 *    images packed tightly together) by giving each tile a CSS grid
 *    row-span computed from the image's own rendered height. No cropping:
 *    every image keeps its natural aspect ratio.
 * 2. Reveals tiles with a "fly in from below" animation as they scroll
 *    into view, using IntersectionObserver.
 *
 * No external dependencies - keeps this scoped to the gallery template
 * instead of touching the theme's main build pipeline.
 */
(function () {
    'use strict';

    var grid = document.getElementById('gh-gallery-grid');
    if (!grid) {
        return;
    }

    var items = Array.prototype.slice.call(grid.querySelectorAll('.gh-gallery-item'));
    if (!items.length) {
        return;
    }

    var prefersReducedMotion = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Small staggered delay so tiles don't all fly in at the exact same
       instant - purely cosmetic, capped low so it never feels laggy. */
    items.forEach(function (item, index) {
        item.style.transitionDelay = (index % 4) * 60 + 'ms';
    });

    /* ---- 1. Masonry row-span layout ---- */

    function rowUnit() {
        var styles = window.getComputedStyle(grid);
        var rowHeight = parseFloat(styles.getPropertyValue('grid-auto-rows')) || 1;
        var rowGap = parseFloat(styles.getPropertyValue('row-gap')) || 0;
        return { rowHeight: rowHeight, rowGap: rowGap };
    }

    function layoutItem(item) {
        var img = item.querySelector('img');
        if (!img || !img.naturalHeight) {
            return;
        }
        var unit = rowUnit();
        var itemHeight = item.getBoundingClientRect().height;
        var span = Math.ceil((itemHeight + unit.rowGap) / (unit.rowHeight + unit.rowGap));
        item.style.gridRowEnd = 'span ' + span;
    }

    function layoutAll() {
        items.forEach(layoutItem);
    }

    items.forEach(function (item) {
        var img = item.querySelector('img');
        if (!img) {
            return;
        }
        if (img.complete && img.naturalHeight) {
            layoutItem(item);
        } else {
            img.addEventListener('load', function () {
                layoutItem(item);
            });
        }
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(layoutAll, 150);
    });

    /* ---- 2. Scroll fly-in reveal ---- */

    if (prefersReducedMotion || typeof IntersectionObserver === 'undefined') {
        items.forEach(function (item) {
            item.classList.add('is-visible');
        });
        return;
    }

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, {
        root: null,
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.01
    });

    items.forEach(function (item) {
        observer.observe(item);
    });
}());
